<template>
    <div>
        <svg :width="iconSize" :height="iconSize" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M6.83625 15.9888C8.09099 17.7864 10.1449 18.8575 12.3371 18.8575C14.5293 18.8575 16.5832 17.7864 17.8379 15.9888H19.6779C18.2674 18.7001 15.4652 20.401 12.409 20.401C9.35272 20.401 6.55049 18.7001 5.14 15.9888H6.83625ZM11.8196 8.69584L13.4583 9.75001L15.5954 8.79167H24L19.9942 15.7204H13.9854L14.3208 14.7621L12.2413 15.7204H9.165L8.03417 14.9346L7.46875 15.7204H1L5.00583 8.69584H11.8196ZM6.31875 10.555H5.22625V13.8421H6.31875V12.5579H7.27708V13.8421H8.36958V10.555H7.27708V11.6667H6.31875V10.555ZM10.43 10.555H8.91583V13.8421H10.43C10.6345 13.8354 10.8373 13.8032 11.0338 13.7463C11.2227 13.7056 11.3977 13.6164 11.5417 13.4875C11.6883 13.3514 11.8028 13.1845 11.8771 12.9988C11.9718 12.7381 12.0141 12.4613 12.0017 12.1842C12.0032 11.9735 11.9742 11.7636 11.9154 11.5613C11.8708 11.3651 11.7823 11.1816 11.6567 11.0246C11.5344 10.8731 11.3763 10.7545 11.1967 10.6796C10.9542 10.5793 10.6918 10.5367 10.43 10.555ZM13.7267 10.555H12.3371V13.8421H13.2954V11.82L13.8033 13.8421H14.6275L15.1354 11.82V13.8421H16.0938V10.555H14.6275L14.1771 12.3088L13.7267 10.555ZM18.5183 10.555H17.3683L16.1321 13.8421H17.2917L17.445 13.315H18.4704L18.6238 13.8421H19.7833L18.5183 10.555ZM10.1521 11.3888C10.3341 11.3671 10.5164 11.4267 10.6504 11.5517C10.7737 11.7453 10.8277 11.975 10.8038 12.2033C10.8113 12.3816 10.7886 12.5598 10.7367 12.7304C10.703 12.8201 10.6384 12.8949 10.5546 12.9413C10.4277 12.995 10.289 13.0148 10.1521 12.9988H10.0179V11.3888H10.1521ZM17.9338 11.6283L18.2021 12.5196H17.6654L17.9338 11.6283ZM12.4042 4C15.4028 3.99749 18.1633 5.63321 19.6013 8.26459H17.7325C16.4677 6.55271 14.4655 5.54263 12.3371 5.54263C10.2086 5.54263 8.20648 6.55271 6.94167 8.26459H5.21667C6.65296 5.63622 9.40896 4.001 12.4042 4Z"
                :fill="color" 
            />
        </svg>
    </div>
</template>

<script>
export default {
    name: 'IconSvgMEMAHHome',
    props: {
        color: {
            type: String,
            default: '#000000',
        },
        size: {
            type: Number,
            default: null
        }
    },
    computed: {
        iconSize() {
            return this.size ? `${this.size}px` : '44px'
        }
    }
};
</script>

<style scoped></style>